import React from 'react';
import ChronicleStore from './store';
import useStore from '@src/utils/hooks/use-store';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import Page from '@src/components/page';
import cx from 'classnames';
import StorageBox from './components/storage-box';
import LeftOpenBox from './components/left-open-box';
import RightOpenBox from './components/right-open-box';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import toWebpImage from '@src/utils/to-webp-image';
import BackTopFooter from '@src/business-components/backtop-footer';
import NaviBar from '@src/business-components/navibar';

const lang = getLanguageByPath() === 'zh-Hant' ? 'tc' : getLanguageByPath();

const Chronicle = () => {
  const store = useStore(() => {
    return new ChronicleStore();
  });

  return (
    <Page className={cx(store.isLeftTitleOpen)}>
      <NaviBar store={store.naviBarStore} />
      <div className={styles.header}>
        {store.isLeftTitleOpen}
        <div
          className={styles.return}
          onClick={() => {
            // window.history.back();
            store.redirect('/');
          }}
          style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/return.png`))})` }}
        />
        {/* <div
          className={styles.personalCenter}
          onClick={() => {
            store.personalCenterModalStore.isOpen = true;
            store.personalCenterModal.open();
          }}
        /> */}
        <div className={styles.page_line} />
      </div>
      <div className={cx(styles.content, store.isLeftTitleOpen ? styles.bg : styles.bg2)}>
        <div className={styles.timelinepage}>
          {/* 左侧时间轴区域 LeftOpenBox为左侧展开，StorageBox为收纳盒 */}
          {store.isLeftTitleOpen ? <LeftOpenBox store={store.leftOpenBoxStore} /> : <StorageBox store={store.storageBoxStore} />}
          {/* 右侧标签轴区域 RightOpenBox为右侧展开，StorageBox为收纳盒 */}
          {!store.isLeftTitleOpen ? <RightOpenBox store={store.rightOpenBoxStore} /> : <StorageBox store={store.storageBoxStore} />}
        </div>
      </div>
      {/* 底部版权栏 */}
      {<BackTopFooter btns={['copyright']} />}
    </Page>
  );
};

export default wrapStore(Chronicle, ChronicleStore);
